
import Vue from 'vue'
import App from './App'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import userService from "./service/UserService"
import wechatService from "./service/weixinService"
import VueResource from "vue-resource";
import routes from "./router/index.js";
import vueRouter from "vue-router";
import mixin_changeTitle from "./mixin/changeTitle.js";
import {Indicator,Lazyload} from "mint-ui";
import version from "./config/versions";

Vue.config.debug = process.env.NODE_ENV !== "production";

Vue.mixin(mixin_changeTitle)
Vue.use(MintUI);
Vue.use(vueRouter);
Vue.use(VueResource);
Vue.use(Lazyload);

Vue.prototype.userService=userService;
Vue.userService = userService;

Vue.prototype.wechatService=wechatService;
Vue.wechatService = wechatService;

const router = new vueRouter({ routes });

router.beforeEach((to, from, next) => {
    Indicator.open();
    Vue.nextTick(()=>{
        Indicator.close();
    });
    next();

});
router.afterEach(() => {
    Indicator.close();
    Vue.nextTick(()=>{
        Indicator.close();
    });
});

Vue.http.interceptors.push(function(request, next) {
    let sessionId=userService.getModel().getModel().sessionid;
    let validtoken=userService.getModel().getModel().validtoken;
    let params;
    let perssion;
    if(request.method=="POST"){
        params=request.body
    }else{
        params=request.params;
    }
    
    if(typeof params!="undefined"){
        perssion=params.perssionId;
        if(typeof perssion!="undefined"){
            perssion=params.perssionId.toString();
        }else{
            perssion=window.localStorage.getItem("perssionId");
        }
    }
    let token='bearer '+validtoken+","+sessionId;
    var intercep = ["user_login,user_reg,send_reg_checkcode,select_contract_list_by_sign_id,getticket"];
    for (var index in intercep) {
        let str = intercep[index];
        if (request.url.indexOf(str) <= -1) {
            request.headers.set('Authorization', token);
            request.headers.set('ClientPermission', perssion);
        }
    }
    next();


});

//版本检查与脚本执行
version.checkVersion();
new Vue({ router }).$mount("#app");


// WEBPACK FOOTER //
// ./src/main.js